import { useRef, useState, useEffect } from "react";
import useApi from "../hooks/useApi";
import { endpoints } from "../utils/utils";
import { Button, Container, createTheme, ThemeProvider } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


const theme = createTheme({
    palette: {
        white: {
            "main": "#FFFFFF",
            "light": "#FFFFFF",
            "dark": "#FFFFFF",
            "contrastText": "#FFFFFF"
        },
        white_dark: {
            "main": "rgba(255, 255, 255, 0.7)",
            "light": "rgba(255, 255, 255, 0.7)",
            "dark": "rgba(255, 255, 255, 0.7)",
            "contrastText": "#393D44"
        },
        dark_yellow: {
            "main": "#393D44",
            "light": "#393D44",
            "dark": "#393D44",
            "contrastText": "#FAEF9B",
        },
        dark_white: {
            "main": "#393D44",
            "light": "#393D44",
            "dark": "#393D44",
            "contrastText": "#FFFFFF",
        },
        dark: {
            "main": "#393D44",
            "light": "#393D44",
            "dark": "#393D44",
            "contrastText": "#393D44"
        }
    },
});

const ForgetPassword = () => {
    const { t, i18n } = useTranslation('auth');
    const userRef = useRef();
    const [email, setEmail] = useState("");
    const navigate = useNavigate();
    const [errMsg, setErrMsg] = useState("");
    const [successMsg, setSuccessMsg] = useState("");

    const api = useApi();

    useEffect(() => {
        userRef.current.focus();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrMsg("");
        setSuccessMsg("");
        try {
            const response = await api.post(
                `${endpoints.forgetUrl}?email=${encodeURIComponent(email)}`,
                {},
                {
                    headers: { "Content-Type": "application/json" },
                }
            );

            if (response?.data?.success) {
                setSuccessMsg("We've sent you an email to reset your password. Please check your inbox.");
                setTimeout(() => setSuccessMsg(""), 6000);

            } else {
                setErrMsg("Something went wrong. Please try again.");
                setTimeout(() => setErrMsg(""), 6000);
            }
        } catch (err) {
            setErrMsg("Failed to send reset email. Please try again.");
            setTimeout(() => setErrMsg(""), 6000);
        }
    };


    return (
        <div className="main-login">
            <div className="container">
                <div className="admin-left">
                    <div className="logo">Flyspa</div>
                    <div className="form-login">
                        <form onSubmit={handleSubmit}>
                            <div className="form-text">
                                <input
                                    type="email"
                                    name="email"
                                    id="email"
                                    placeholder="Your email address"
                                    className="email"
                                    ref={userRef}
                                    autoComplete="off"
                                    onChange={(e) => setEmail(e.target.value)}
                                    value={email}
                                    required
                                />
                            </div>
                            {errMsg && <p className="error text-center">{errMsg}</p>}
                            {successMsg && <p className="success text-center">{successMsg}</p>}
                            <Container sx={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap', padding: '0 !important' }}>
                                <ThemeProvider theme={theme}>
                                    <Button name="reset" id="reset_password" type="submit" variant="contained" color='white_dark'
                                        sx={{ marginTop: '15%', fontSize: '18px', textTransform: 'none', borderRadius: '15px', width: '100%', maxWidth: '315px', minHeight: '57px', gap: '5px' }}><img src='assets/images/icon-login.svg' alt='login' /> {t('auth:reset')}</Button>
                                    <Button variant="contained" color='dark_yellow' onClick={() => navigate('/login')} sx={{ fontSize: '18px', textTransform: 'none', borderRadius: '15px', width: '100%', maxWidth: '315px', minHeight: '57px' }}> {t('auth:retour_login')}</Button>
                                </ThemeProvider>
                            </Container>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgetPassword;
